import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function fetchLeads(token) {
  const { data } = await api.get("/admin/leads", {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

export async function fetchStats(token) {
  const { data } = await api.get("/admin/stats", {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

export async function sendBriefEmail(payload) {
  const { data } = await api.post("/brief-email", payload);
  return data;
}

export async function fetchAnalytics(token) {
  const { data } = await api.get("/admin/analytics", {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

export async function fetchBriefEmails(token) {
  const { data } = await api.get("/admin/brief-emails", {
    headers: { "X-Admin-Token": token },
  });
  return data;
}
